import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

const load = () => {
  try {
    return JSON.parse(localStorage.getItem("cineblue-cart") || "[]");
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);

  useEffect(() => {
    localStorage.setItem("cineblue-cart", JSON.stringify(items));
  }, [items]);

  const addItem = (pkg, quantity = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.slug === pkg.slug);
      if (found) {
        return prev.map((i) =>
          i.slug === pkg.slug ? { ...i, quantity: Math.min(i.quantity + quantity, 20) } : i
        );
      }
      return [
        ...prev,
        {
          slug: pkg.slug,
          title: pkg.title,
          price: pkg.price,
          image: pkg.image,
          tag: pkg.tag,
          quantity,
        },
      ];
    });
  };

  const updateQuantity = (slug, delta) => {
    setItems((prev) =>
      prev
        .map((i) => (i.slug === slug ? { ...i, quantity: Math.max(0, i.quantity + delta) } : i))
        .filter((i) => i.quantity > 0)
    );
  };

  const removeItem = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const clearCart = () => setItems([]);

  const total = useMemo(
    () => items.reduce((sum, i) => sum + i.price * i.quantity, 0),
    [items]
  );
  const count = useMemo(() => items.reduce((sum, i) => sum + i.quantity, 0), [items]);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQuantity, removeItem, clearCart, total, count }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
